import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Modelo", -1)
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_RegistersTable = _resolveComponent("RegistersTable")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h3", _hoisted_4, "Modelo: " + _toDisplayString(_ctx.schemaModel.model), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Form, {
        id: "kt_account_profile_details_form",
        class: "form",
        novalidate: "novalidate",
        onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveChanges1())),
        "validation-schema": _ctx.profileDetailsValidator
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "model",
                      class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                      placeholder: "Modelo",
                      modelValue: _ctx.schemaModel.model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.schemaModel.model = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode(_component_ErrorMessage, { name: "model" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_RegistersTable, {
                "widget-classes": "card-xxl-stretch mb-5 mb-xl-8",
                numregisters: _ctx.schemaModel.registersDescription
              }, null, 8, ["numregisters"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}